import { type SocketMachineContext } from '../../../network-state-machine-context';

type ErrorContext = Pick<
  SocketMachineContext,
  'socketDisposeListeners' | 'webSocket' | 'debounce' | 'error'
>;

export function onEnterError(ctx: ErrorContext) {
  ctx.socketDisposeListeners?.();
  ctx.webSocket?.close();
  ctx.webSocket = undefined;
  ctx.socketDisposeListeners = undefined;

  if (ctx.error) {
    ctx.debounce.captureError(ctx.error);
  }
}
